// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__ZorMa","powerbiContainer":"Dashboard_powerbiContainer__Zv3ZV"};